// src/pages/TariffsAndRulesPage.jsx
import React, { useEffect, useRef } from "react";
import Header from "../components/Header";

/**
 * Tariffs & Rules (adamftd.org) embed — React-safe implementation
 *
 * Keep index.html free of inline embed scripts to avoid race conditions.
 */
const SCRIPT_SRC = "https://adamftd.org/cdn/embed.js";
const SCRIPT_ATTR = "data-adamftd-embed"; // marker to avoid duplicates
const CONTAINER_ID = "adamftd-embedded-container"; // matches your snippet

export default function TariffsAndRulesPage() {
  const containerRef = useRef(null);
  const initedRef = useRef(false); // Strict Mode guard

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const initEmbed = () => {
      if (initedRef.current) return;
      if (
        !window.adamftd_embedded ||
        typeof window.adamftd_embedded.load !== "function"
      ) {
        console.error("adamftd embed API not available after script load");
        return;
      }
      initedRef.current = true;
      window.adamftd_embedded.load({
        apiKey: "1uygX8zrZFBl8XYTJGmABRNKszdYNVzRMgWgXQKGxIg",
        affiliateCode: "prolognet978",
        containerId: CONTAINER_ID,
        url: "https://adamftd.org/public/tariffs_and_rules",
      });
    };

    const ensureScript = () =>
      new Promise((resolve, reject) => {
        const existing = document.querySelector(`script[${SCRIPT_ATTR}]`);
        if (existing) {
          if (window.adamftd_embedded) resolve();
          else existing.addEventListener("load", resolve, { once: true });
          existing.addEventListener("error", reject, { once: true });
          return;
        }
        const s = document.createElement("script");
        s.src = SCRIPT_SRC;
        s.defer = true;
        s.async = true;
        s.setAttribute(SCRIPT_ATTR, "true");
        s.addEventListener("load", resolve, { once: true });
        s.addEventListener(
          "error",
          () => reject(new Error("Failed to load adamftd embed script")),
          { once: true }
        );
        document.head.appendChild(s);
      });

    let cancelled = false;
    ensureScript()
      .then(() => {
        if (!cancelled) initEmbed();
      })
      .catch((err) => {
        console.error(err);
        if (container)
          container.textContent =
            "Failed to load Tariffs & Rules. Please retry.";
      });

    return () => {
      cancelled = true;
      if (container) container.innerHTML = ""; // clear UI on unmount
    };
  }, []);

  return (
    <>
      <div>
        <Header />
      </div>

      <div
        style={{
          marginTop: "120px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      ></div>
      <div
        id={CONTAINER_ID}
        ref={containerRef}
        style={{ width: "1200px", height: "1000px", margin: "auto" }}
        aria-label="Tariffs and Rules"
      />
    </>
  );
}
